
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { link } from 'bits/autolinker'
import { getDisplayAttributes } from 'bits/beethoven'
import { $ } from 'bits/jquery'
import { getHostnameFromUrl } from 'bits/location'
import { mathifyElement } from 'bits/math'

const autoLink = (text: string): string => {
  return link(text, {
    replaceFn: (match) => {
      const tag = match.buildTag()
      tag.setAttr('rel', 'noopener nofollow ugc')
      tag.setAttr('data-bridged-link', 'external')
      return tag
    },
  })
}

@Component({})
export default class SurfacePostBody extends Vue {
  $refs!: {
    postBody: HTMLParagraphElement
  }

  @Prop({ required: true }) content!: string
  @Prop({ default: 'auto' }) darkMode!: boolean | 'auto'
  @Prop({ default: false }) isTextSelectable!: boolean

  @Getter isApp!: boolean

  get body(): string {
    return autoLink(this.content)
  }

  mounted(): void {
    this.performPostUpdateActions()
  }

  @Watch('content')
  onContentChange(): void {
    this.performPostUpdateActions()
  }

  performPostUpdateActions(): void {
    this.$nextTick(() => {
      this.mathifyPostBody()
      this.setExternalLinksForNativeBridge()
      this.$nextTick(() => {
        this.makeBodyPadletLinksInternalForNativeBridge()
      })
    })
  }

  mathifyPostBody(): void {
    $(this.$refs.postBody)
      .find('var')
      .each((_, el) => {
        if (!el.children[0] || el.children[0].className !== 'katex') {
          mathifyElement(el)
        }
      })
  }

  setExternalLinksForNativeBridge(): void {
    $(this.$refs.postBody)
      .find('a[href^=h]')
      .attr({ target: '_blank', rel: 'noopener nofollow ugc', 'data-bridged-link': 'external' })
  }

  // check to see if the url links to a padlet and set data-bridged-link to internal
  async makeBodyPadletLinksInternalForNativeBridge(): Promise<void> {
    if (!this.isApp || !this.$refs.postBody) return

    const bodyAnchorTags = this.$refs.postBody.querySelectorAll('a[href^=h]')
    for (const anchorTag of bodyAnchorTags) {
      const hrefUrl = anchorTag.getAttribute('href')
      if (!hrefUrl) continue

      const hrefHost = getHostnameFromUrl(hrefUrl)
      if (/(padlet|padletorg)\.(com|org|io|test|dev)/.test(hrefHost)) {
        // the fetchLink request in bits/beethoven.ts is memoized so this shouldn't fire too many requests
        const urlDisplayAttributes = await getDisplayAttributes(hrefUrl)

        // All pages from padlet have content_subcategory === 'padlet'
        // provider_name for a wall is the builder's name, "padlet" should be used only for landside pages (e.g. padlet.com, padlet.com/features)
        const isPadletWallUrl =
          urlDisplayAttributes?.content_subcategory === 'padlet' &&
          urlDisplayAttributes?.provider_name.toLowerCase() !== 'padlet'

        if (isPadletWallUrl) {
          anchorTag.setAttribute('data-bridged-link', 'padlet')
        }
      }
    }
  }
}
